  export default [
    "#ff6a10",
    "#00a1f4",
    "#50ea00",
    "#a249da",
    "#60ff67",
    "#e887ff",
    "#3bffa2",
    "#ff5c74",
    "#00ad8c",
    "#d43a4b",
    "#02b1b5",
    "#cb4266",
    "#f6ffad",
    "#996197",
    "#ffcd64",
    "#c0e3ff",
    "#a96148",
    "#ff89b6",
    "#6c7957",
    "#996952"
  ];